import {
  GET_FALLBACK_MESSAGE_SERVLET_PENDING,
  GET_FALLBACK_MESSAGE_SERVLET_FAILED,
  GET_FALLBACK_MESSAGE_SERVLET_FULFILLED,
  RESET_USER_ACCOUNT,
} from "constants-lib/actionTypes"
import { API_STATUSES } from "constants-lib/common"

const initialState = {
  getServletFallbackMessageStatus: "",
  servletFallbackMessage: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FALLBACK_MESSAGE_SERVLET_PENDING:
      return {
        ...state,
        getServletFallbackMessageStatus: API_STATUSES.PENDING,
      }
    case GET_FALLBACK_MESSAGE_SERVLET_FULFILLED:
      return {
        ...state,
        getServletFallbackMessageStatus: API_STATUSES.FULFILLED,
        servletFallbackMessage: action.payload,
      }
    case GET_FALLBACK_MESSAGE_SERVLET_FAILED:
      return {
        ...state,
        getServletFallbackMessageStatus: API_STATUSES.FAILED,
      }

    case RESET_USER_ACCOUNT:
      return {
        ...initialState,
      }

    default:
      return state
  }
}
